import CreatableSelect from 'react-select/creatable';
import { Props } from 'react-select';

const CreatableSelectComponent = ({ ...props }: Props): JSX.Element => {
  return <CreatableSelect {...props} />;
};

export default CreatableSelectComponent;
